module.exports = __webpack_public_path__ + "img/brasao-gerente-regional.47a6bd0c.png";